module.exports = __webpack_public_path__ + "img/1f34c.1e4b217.svg";